export default "__VITE_ASSET__CQXwIzIq__"